import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
const ErrorMessageModal = (props) => {
    const [modalStatus, toggleModal] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: () => toggleModal(!modalStatus), variant: "outline-danger", size: "sm" }, "Show"),
        React.createElement(Modal, { show: modalStatus, onHide: () => toggleModal(!modalStatus) },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, "Error details")),
            React.createElement(Modal.Body, null, props.errorMessage))));
};
export default ErrorMessageModal;
